export const MAX_VISIBLE_COUNT = 2;
